<template>
  <div class="d-flex align-items-center justify-content-center min-vh-100">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="12" md="6" lg="4">
          <b-card class="p-3 shadow-sm rounded-lg">
            <div class="text-center">
              <b-link :to="{ name: 'Login' }">
                <img :src="appLogoImage" class="img-fluid" width="200" />
              </b-link>
            </div>

            <b-card-title class="font-weight-bold text-dark text-center mt-3">
              Forgot password?
            </b-card-title>
            <b-card-text class="text-muted text-center">
              Please enter the email associated with your account,<br />
              and we will send you a code to reset your password.
            </b-card-text>

            <validation-observer ref="forgotPasswordFormValidation">
              <b-form @submit.prevent>
                <b-form-group label-for="email">
                  <validation-provider #default="{ errors }" name="Email" rules="required|email">
                    <b-form-input
                      id="email"
                      v-model="email"
                      :state="errors.length > 0 ? false : null"
                      name="email"
                      placeholder="Enter Email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button type="submit" variant="primary" block @click="validateForm">
                  Send Verification Code
                </b-button>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { $themeConfig } from "@themeConfig";
import { mapActions } from "vuex";
import util from "@/util.js";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [util],
  data() {
    return {
      email: "",
      required,
      appLogoImage: $themeConfig.app.appLogoImage,
    };
  },
  methods: {
    ...mapActions({ requestReset: "appData/requestReset" }),
    async validateForm() {
      const success = await this.$refs.forgotPasswordFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try {
        const res = await this.requestReset({ payload: { email: this.email } });
        if (res.status === 200) {
          this.$router.push({ name: "VerificationCode", params: { email: this.email } });
        }
      } catch (error) {
        this.displayError(error);
      }
    },
  },
};
</script>

<style scoped>
.min-vh-100 {
  min-height: 100vh;
}
</style>